'use strict';

angular.module('billings').factory('Subscription',  ['$resource',
    function($resource) {
        return $resource('billings/subscribe/:subscriptionId', { billingId: '@_id'
        }, {
            update: {
                method: 'PUT'
            },
			getAll: {
				url: '/billings/subscriptions',
				method:'GET',
				cache : false
			},
			getUpgradeInfo: {
				url: '/billings/subscription-upgrade-info',
				method:'POST',
				cache : false
			},
			getSubscriptionPlansAllowed: {
				url: '/billings/subscription-plans-allowed',
				method:'GET',
				cache : false
			}
        });
    }
]);
